import { DetailTag } from "./DetailTag";
import style from "./style.module.scss";

interface RenderMovementProps {
  movement?: any | null;
  field: "start" | "end" | "nature" | "tonnage";
}

const formatTime = (value?: string) => {
  if (!value) return "";

  const hourFormat = value.match(/(\d{2})h(\d{2})$/);

  if (hourFormat) {
    return `${hourFormat[1]}:${hourFormat[2]}`;
  }

  const colonFormat = value.match(/(\d{2}):(\d{2})$/);

  if (colonFormat) {
    return `${colonFormat[1]}:${colonFormat[2]}`;
  }

  return value;
};

export const RenderMovement = ({ movement, field }: RenderMovementProps) => {
  /*
   * Ligne de compensation :
   * l'autre côté contient un mouvement mais pas celui-ci.
   */
  if (!movement) {
    return null;
  }

  if (field === "start") {
    return (
      <div className={style.timesheet_and_overtimework__movement__time}>
        {formatTime(movement?.startAt) || "--"}
      </div>
    );
  }

  if (field === "end") {
    return (
      <div className={style.timesheet_and_overtimework__movement__time}>
        {formatTime(movement?.endAt) || "--"}
      </div>
    );
  }

  if (field === "tonnage") {
    return (
      <div className={style.timesheet_and_overtimework__movement__tonnage}>
        {movement?.tonnageVolumeLabel ?? "--"}
      </div>
    );
  }

  const details = (movement?.nature?.detail ?? []).filter(Boolean);

  return (
    <div className={style.timesheet_and_overtimework__movement__nature}>
      <div className={style.timesheet_and_overtimework__movement__label}>
        {movement?.nature?.label ? (
          movement.nature.label
        ) : movement?.auxiliary ? (
          <div
            className={style.timesheet_and_overtimework__movement__auxiliary}
          >
            {movement.auxiliary}
          </div>
        ) : (
          "--"
        )}
      </div>

      {details.length > 0 && (
        <div className={style.timesheet_and_overtimework__movement__details}>
          {details.map((detail: string, detailIndex: number) => (
            <DetailTag key={`${detail}-${detailIndex}`} value={detail} />
          ))}
        </div>
      )}
    </div>
  );
};
